import React from 'react';
import { Modal, Button } from '@themesberg/react-bootstrap';

const LoaderDetailsModal = (props) => {
  const { show, handleClose, loader, handleConfirm } = props;
  console.log(loader);
  return (
    <Modal centered show={show} onHide={handleClose} size="xl">
      <Modal.Header className="d-flex w-100 justify-content-between mb-2">
        <h4>Loader Details</h4>
        <Button variant="close" aria-label="Close" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body className="pt-0">
        <div
          className="d-flex gap-2 width-100 p-2 justify-content-between mb-2"
          style={{ backgroundColor: '#F0F0F0' }}
        >
          <div>
            <p>Loader Code</p>
            <p>{loader?.loaderCode}</p>
          </div>
          <div>
            <p>Loader Name</p>
            <p>{loader?.name}</p>
          </div>
          <div>
            <p>Mobile No</p>
            <p>{loader?.mobileNo}</p>
          </div>
          <div>
            <p>Agency</p>
            <p>{loader?.agency}</p>
          </div>
          <div>
            <p>Warehouse</p>
            <p>{loader?.storeCode}</p>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleConfirm}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default LoaderDetailsModal;
